module.exports = __webpack_public_path__ + "static/media/article-blog-img3.39fa4aa4.png";